export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7769.26986b1a.jpg";